export const ROUTE_AFTER_LOGIN_KEY = "ROUTE_AFTER_LOGIN";
export const PREVIOUS_CREDENTIALS_KEY = "PREVIOUS_CREDENTIALS";